import React, { useState, useEffect } from "react";
import {
  COURSE_DETAILS_LIVE_CLASSES_HEADING,
  LOCKED_TOAST_TEXT,
  VIDEO_TYPE_YOUTUBE_LIVE,
  PAGE_LIMIT,
  LIVE_CLASS_NOT_STARTED_TOAST_TEXT,
} from "../../constants/text_constants";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { formatDate } from "../../utils/util-functions/formatDate";
import CALENDAR_ICON from "../../assets/CalendarBlank.png";
import { convertTo12HourFormat } from "../../utils/util-functions/formatTime";
import PLAY_ICON from "../../assets/Play.png";
import LOCK_ICON from "../../assets/Lock.png";
import LOCK_OPEN_ICON from "../../assets/LockSimpleOpen.png";
import { toast } from "sonner";
import CountdownTimer from "../Countdown/Countdown";
import CLOCK_ICON from "../../assets/Timer.png";
import { hasDateTimePassed } from "../../utils/hasDateTimePassed";
import InValidLottie from "../Lottie-Components/InValidLottie";
import { useNavigate, useLocation } from "react-router-dom";
import { PROTECTED_ROUTES } from "../../routes/routes";
import userLogout from "../../utils/userLogout";
import { useDispatch } from "react-redux";
import IntegratedPagination from "../Pagination/IntegratedPagination";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import handleBuy from "../Buy/handleBuy";
import { ITEM_COURSE } from "../../constants/text_constants";

const LiveClassesTab = ({ courseId, isPurchased, data }) => {
  const [liveClassData, setLiveClassData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const userAuthenticated = sessionStorage.getItem("authenticated") === "1";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  const fetchCourseLiveClasses = async (retries = 6) => {
    try {
      const authToken = sessionStorage.getItem("token");
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_COURSE_DETAILS_LIVE_CLASSES +
        courseId +
        "&limit=10&page=" +
        currentPage,
        requestOptions
      );
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchCourseLiveClasses(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setTotalPages(Math.ceil(json?.data?.total / PAGE_LIMIT));
      setLiveClassData(json?.data);
    } catch (err) {
      console.error("Error", err);
    }
  };

  useEffect(() => {
    if (userAuthenticated) {
      fetchCourseLiveClasses();
    } else {
      return;
    }
  }, [courseId, currentPage]);

  function handleClick(video_type, premier_datetime, id) {
    if (isPurchased === "0") {
      setIsModalOpen(true);
    } else {
      if (liveClassData?.is_locked) {
        setIsModalOpen(true);
      }
      if (!liveClassData?.is_locked) {
        const hasDateTimePassedResponse = hasDateTimePassed(premier_datetime);
        if (!hasDateTimePassedResponse) {
          toast(LIVE_CLASS_NOT_STARTED_TOAST_TEXT);
        }
        if (hasDateTimePassedResponse) {
          if (video_type === VIDEO_TYPE_YOUTUBE_LIVE) {
            // navigate to custom live player -> /live
            navigate(PROTECTED_ROUTES?.live + `/${id}`);
          } else {
            // navigate to custom player -> /classroom
            console.log("Normal Player");
          }
        }
      }
    }
  }

  if (!userAuthenticated) {
    return (
      <div className="mb-[58px] md:mb-0">
        <div className="text-2xl font-semibold my-6">
          {COURSE_DETAILS_LIVE_CLASSES_HEADING}
        </div>
        <div>
          <InValidLottie text={"You Need to Login to view Classroom"} />
        </div>
      </div>
    );
  }

  if (liveClassData?.total === 0) {
    return (
      <div>
        <InValidLottie text={"No Live Classes as of now !"} />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "DM Sans" }}>
      <div className="lg:text-2xl text-lg font-semibold my-6">
        {COURSE_DETAILS_LIVE_CLASSES_HEADING}
      </div>
      {!userAuthenticated && (
        <div>
          <InValidLottie text={"You Need to Login to view Live Classes"} />
        </div>
      )}
      {!liveClassData && <div>.</div>}
      <div className="grid grid-rows-1 gap-5">
        {liveClassData?.lectures.map((ele, i) => (
         <div
  key={i}
  onClick={() =>
    handleClick(ele?.video_type, ele?.premier_datetime, ele?.id)
  }
  className="bg-white rounded-xl border border-[#E5E7EB] shadow-sm hover:shadow-md transition-all duration-200 p-3 flex flex-col md:flex-row gap-3 cursor-pointer relative"
>
  {/* LOCK ICON */}
  {(liveClassData?.is_locked ||
    !hasDateTimePassed(ele?.premier_datetime)) && (
    <div className="absolute top-2 left-2 bg-gray-200 p-1 rounded-full z-10">
      <img src={LOCK_ICON} className="w-4 h-4" />
    </div>
  )}

  {!liveClassData?.is_locked &&
    hasDateTimePassed(ele?.premier_datetime) && (
      <div className="absolute top-2 left-2 bg-cyan-500 p-1 rounded-full z-10">
        <img src={LOCK_OPEN_ICON} className="w-4 h-4" />
      </div>
    )}

  {/* LEFT SECTION */}
  <div className="flex gap-3 w-full md:w-[65%]">
    
    {/* THUMBNAIL 16:9 */}
    <div className="relative w-[120px] md:w-[160px] aspect-video flex-shrink-0">
      <img
        src={ele?.thumbnail}
        alt={ele?.title}
        className="w-full h-full object-cover rounded-lg"
      />

      {/* PLAY OVERLAY (optional 🔥) */}
      <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded-lg">
        <div className="bg-white/90 p-2 rounded-full">
          <img src={PLAY_ICON} className="w-4 h-4" />
        </div>
      </div>
    </div>

    {/* TEXT */}
    <div className="flex flex-col justify-between w-full">
      <div>
        <div className="font-semibold text-sm md:text-base line-clamp-2">
          {ele?.title}
        </div>
        <div className="text-xs text-gray-500 line-clamp-2 mt-1">
          {stripHtml(ele?.description)}
        </div>
      </div>
    </div>
  </div>

  {/* RIGHT SECTION */}
  <div className="flex flex-col md:flex-row md:items-center gap-2 w-full md:w-auto">

    {/* DATE + TIMER */}
    <div className="text-xs md:text-sm text-gray-600">
      <div className="flex items-center gap-2">
        <img src={CALENDAR_ICON} className="w-4 h-4" />
        <span>
          {formatDate(ele?.premier_datetime)} •{" "}
          {convertTo12HourFormat(ele?.premier_datetime)}
        </span>
      </div>

      <div className="flex items-center gap-2 mt-1">
        <img src={CLOCK_ICON} className="w-4 h-4" />
        <CountdownTimer targetDate={ele?.premier_datetime} />
      </div>
    </div>

    {/* PLAY BUTTON (RIGHT SIDE FIXED) */}
    <div className="flex justify-end md:justify-center md:items-start">
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleClick(
            ele?.video_type,
            ele?.premier_datetime,
            ele?.id
          );
        }}
        className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-md hover:scale-110 transition-all"
      >
        <img src={PLAY_ICON} className="w-4 h-4" />
      </button>
    </div>
  </div>
</div>
        ))}
      </div>
      <div className="mt-[4rem]">
        <IntegratedPagination
          currentPage={currentPage + 1}
          totalPages={totalPages}
          setCurrentPage={(page) => setCurrentPage(page - 1)}
        />
      </div>
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent
          className="
      w-[90%]
      max-w-sm
      sm:max-w-md
      lg:max-w-lg
      h-auto
      p-5
      rounded-xl
    "
        >
          <DialogHeader className="text-center">
            <DialogTitle className="text-xl sm:text-2xl text-[#5A277C] font-semibold">
              Buy Course
            </DialogTitle>

            <DialogDescription className="mt-2 text-sm sm:text-base">
              To access this course. Please buy this course 😊
            </DialogDescription>
          </DialogHeader>

          <DialogFooter className="mt-4 flex justify-center">
            <Button
              type="button"
              className="bg-[#5A277C] hover:bg-purple-700 w-full sm:w-auto"
              onClick={() =>
                handleBuy(
                  dispatch,
                  navigate,
                  data?.id,
                  ITEM_COURSE,
                  data?.name,
                  data?.offer_price,
                  data?.offer_discount,
                  data?.price,
                  data?.principal_amount,
                  data?.course_banner,
                  data?.course_icon
                )
              }
            >
              Buy Now
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

    </div>
  );
};

export default LiveClassesTab;
